/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { addTranslations } from 'libs/i18n';
import enUsTranslations from '../locales/en-us/translations.json';
addTranslations(enUsTranslations);

export * from '../Components/AppManager/AppManager';
export * from '../Components/DxpFrame/DxpFrame';
export * from '../Components/ToolbarTenantSwitcher/ToolbarTenantSwitcher';
